import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { AgritourismService } from '../../../services/agritourism.service';
import { AgritourismAlertService } from '../../../services/alert.service';

@Component({
  selector: 'curbnturf-agritourism-day-five',
  templateUrl: './day-five.component.html',
  styleUrls: ['./day-five.component.scss'],
  standalone: true,
  imports: [RouterModule, VgCoreModule, VgOverlayPlayModule, VgBufferingModule, VgControlsModule],
})
export class AgritourismDayFiveComponent {
  constructor(
    private agritourismService: AgritourismService,
    private alertService: AgritourismAlertService,
    private router: Router,
  ) {}

  complete() {
    this.agritourismService.complete(5).subscribe(() => {
      this.alertService.alert('success', 'You have completed the Agritourism Challenge Course.', 'Congratulations!');
      this.router.navigate(['', 'course']);
    });
  }
}
